export interface AccountBootstrapOptions {
  activeAccountUuid?: string;
  initialAccountUuid?: string;
  queryAccountUuid?: string;
}

export function resolvePageAccountUuid({
  initialAccountUuid,
  queryAccountUuid,
}: Pick<AccountBootstrapOptions, 'initialAccountUuid' | 'queryAccountUuid'>): string | undefined {
  return initialAccountUuid ?? queryAccountUuid;
}

export function resolveEffectiveAccountUuid({
  activeAccountUuid,
  initialAccountUuid,
  queryAccountUuid,
}: AccountBootstrapOptions): string | undefined {
  return activeAccountUuid ?? resolvePageAccountUuid({ initialAccountUuid, queryAccountUuid });
}
